import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledLoadingPlaceholder = styled.div.withConfig({
  displayName: "LoadingPlaceholder__StyledLoadingPlaceholder"
})(({
  height,
  theme
}) => ({
  background: 'var(--bg-color)',
  height: `${height}px`,
  width: `100%`,
  position: 'relative',
  overflow: 'hidden',
  zIndex: 1 /* Necessary for overflow: hidden to work correctly in Safari */,
  borderRadius: '3px',
  display: 'block',
  ['@keyframes loading-skeleton']: {
    '100%': {
      transform: 'translateX(5%)'
    }
  },
  '&::after': {
    animation: 'loading-skeleton 1s ease-in-out infinite',
    backgroundImage: 'var(--highlight-gradient)',
    backgroundRepeat: 'no-repeat',
    display: 'var(--animation-display)',
    position: 'absolute',
    transform: 'translateX(-100%)',
    height: '200%',
    width: '400%',
    zIndex: 100,
    content: `' '`
  },
  [`@media (prefers-reduced-motion)`]: {
    '--animation-display': 'none' /* Disable animation */
  },
  [`--highlight-gradient`]: `linear-gradient(-45deg, #ffffff00 35%, ${theme.color['border-core-subtle']} 50%, #ffffff00 65%)`,
  [`--bg-color`]: `linear-gradient(99deg, ${theme.color['fill-tertiary-hover']}, ${theme.color['fill-tertiary-pressed']})`
}));
export const LoadingPlaceHolder = ({
  width,
  height
}) => {
  return /*#__PURE__*/_jsx(StyledLoadingPlaceholder, {
    "aria-busy": true,
    "data-loading": true,
    height: height,
    width: width
  });
};